import React, { useState, lazy, Suspense } from 'react'
import { Link } from 'gatsby'
import Fade from 'react-reveal/Fade'
import styled from 'styled-components'
import closeIcon from '../../img/close-icon.svg'
import plusIcon from '../../img/plus-icon.svg'
import minusIcon from '../../img/minus-icon.svg'
import { Map, Marker, Overlay, ZoomControl } from 'pigeon-maps'
import logo from '../../img/logo.png'
import LazyLoad from 'react-lazyload'
import { StaticImage } from 'gatsby-plugin-image'
import { ThemeContext } from '../ThemeContext'

const LocationMap = lazy(() => import('../LocationMap'))
const renderLoader = () => <p>Loading...</p>

const FooterTemplate = (props) => {
  const { colorMode } = React.useContext(ThemeContext)
  const isSSR = typeof window === 'undefined'
  // const [id, setId ] = useState(null)
  const [showAboutLinks, setShowAboutLinks] = useState(false)
  const [showExploreLinks, setShowExploreLinks] = useState(false)
  const [showHelpLinks, setShowHelpLinks] = useState(false)
  const [showPrivacyLinks, setShowPrivacyLinks] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  // const color = `hsl(${hue % 360}deg 39% 70%)`
  const color = '#0067AD'
  // const [colorMode, setColorMode] = useColorMode()
  // const isDark = colorMode === `dark`

  function renderInfo () {
    return (
      showInfo ?
        <InfoBg>
          <InfoCloseBtn onClick={() => setShowInfo(false)}>
            <img src={closeIcon} alt='Schließen' style={{ width: '2.5rem', height: '2.5rem' }} />
          </InfoCloseBtn>
          <b><p className='has-text-centered'>Anfahrt</p></b>
          <br />
          <p>Bei der Anschlussstelle Amstetten West (123) von der Westautobahn (A1/E60) abfahren und die B1 in Richtung Amstetten West nehmen.</p>
        </InfoBg>
        : null
    )
  }

  function handleShowAboutLinks (e) {
    e.preventDefault()
    setShowAboutLinks(!showAboutLinks)
  }

  function handleShowExploreLinks (e) {
    e.preventDefault()
    setShowExploreLinks(!showExploreLinks)
  }

  function handleShowHelpLinks (e) {
    e.preventDefault()
    setShowHelpLinks(!showHelpLinks)
  }

  function handleShowPrivacyLinks (e) {
    e.preventDefault()
    setShowPrivacyLinks(!showPrivacyLinks)
  }

  const { data } = props
  const { mainpitch } = data

  // const logoFooter = getImage(mainpitch.logo)

  return (
    <div style={{ position: 'relative' }}>

      <footer style={{ background: 'var(--color-background' }} className='footer'>
        <LazyLoad height={300} once>
          

          <div style={{ margin: '2rem auto 4rem'}}>

            <h4 className='title is-3 is-uppercase has-text-centered has-text-weight-medium' style={{ color: 'var(--color-text)' }}>
              <span className='has-text-primary'>{mainpitch.title}</span>
            </h4>

            <div className='has-text-centered'>
              {colorMode === 'dark' ?
                <StaticImage
                  src='../../img/logo-transparent-white.png'
                  alt='footer-logo'
                  width={150}
                  style={{ margin: '.5rem auto 2rem'}}
                />
              :
              <StaticImage
                  src='../../img/logo.png'
                  alt='footer-logo'
                  width={150}
                  style={{ margin: '.5rem auto 2rem'}}
                />
              }
            </div> 
            
            <h4 className='title is-5 is-size-4-mobile has-text-centered' style={{ color: 'var(--color-text)' }}>
              {mainpitch.subtitle}
            </h4>
          </div>

          <DesktopLinks>
            <div className='columns is-mobile is-centered is-multiline is-paddingless'>
              <div className='column is-3'>
                <div style={{ width: '120px', textAlign: 'left', margin: '0 auto' }}>
                  <h4 style={{ color: 'var(--color-text)'}} className='subtitle is-6 has-text-weight-medium'>
                    Verein
                  </h4>
                  <FooterLink>
                    <Link to='/geschichte' className='has-text-primary'>Geschichte</Link>
                  </FooterLink>

                  <FooterLink>
                    <Link to='/stadion' className='has-text-primary'>Stadion</Link>
                  </FooterLink>

                  <FooterLink>
                    <Link to='/funktionäre/' className='has-text-primary'>Funktionäre</Link>
                  </FooterLink>

                  <FooterLink>
                    <Link to='/sponsoren-und-partner' className='has-text-primary'>Sponsoren</Link>
                  </FooterLink>
                  
                </div>
              </div>

              <div className='column is-3'>
                <div style={{ width: '120px', textAlign: 'left', margin: '0 auto' }}>
                  <h4 style={{ color: 'var(--color-text)' }} className='subtitle is-6 has-text-weight-medium'>
                    Entdecken
                  </h4>
                  <FooterLink>
                   <Link to='/mannschaften/' className='has-text-primary'>Mannschaften</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to='/#news' className='has-text-primary'>News</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to='/#termine' className='has-text-primary'>Termine</Link>
                  </FooterLink>
                  
                </div>
              </div>

              <div className='column is-3'>
                <div style={{ width: '120px', textAlign: 'left', margin: '0 auto' }}>
                  <h4 style={{ color: 'var(--color-text)', whiteSpace: 'nowrap' }} className='subtitle is-6 has-text-weight-medium'>
                    Kontakt
                  </h4>

                  {/*<a href={'tel:' + mainpitch.telefon} className='has-text-primary'>Telefon</a>*/}
                  <FooterLink>
                  {/* <a href={'tel:+436643552306'} className='has-text-primary'>Telefon</a> */}
                  </FooterLink>
                  {!isSSR && (
                    <Suspense fallback={renderLoader()}>
                      <LocationMap />
                    </Suspense>
                  )}
                </div>
              </div>

              <div className='column is-3'>
                <div style={{ width: '120px', textAlign: 'left', margin: '0 auto' }}>
                  <h4 style={{ color: 'var(--color-text)' }} className='subtitle is-6 has-text-weight-medium'>
                    Rechtliches
                  </h4>
                  <FooterLink>
                    <Link to='/impressum/' className='has-text-primary'>Impressum</Link>
                  </FooterLink>
                  <FooterLink>
                    <Link to='/datenschutz/' className='has-text-primary'>Datenschutz</Link>
                  </FooterLink>
                </div>
              </div>
            </div>
          </DesktopLinks>

          <MobileExpander onClick={handleShowAboutLinks}>
            <h4 className='subtitle is-6 has-text-weight-medium' style={{ color: 'var(--color-text)', display: 'inline-block', margin: '0px' }}>
              Verein
            </h4>
            {showAboutLinks ? <img src={minusIcon} alt='schließen' style={{ width: '1.4rem', height: '1.4rem' }} className='is-pulled-right' onClick={handleShowAboutLinks} /> : <img src={plusIcon} alt='öffnen' className='is-pulled-right' style={{ width: '1.4rem', height: '1.4rem' }} onClick={handleShowAboutLinks} /> }

            <Fade collapse when={showAboutLinks}>
              <FooterLink>
                <Link to='/geschichte/' className='has-text-primary'>Geschichte</Link>
              </FooterLink>

              <FooterLink>
                <Link to='/stadion/' className='has-text-primary'>Stadion</Link>
              </FooterLink>

              <FooterLink>
                <Link to='/funktionäre/' className='has-text-primary'>Funktionäre</Link>
              </FooterLink>

              <FooterLink>
                <Link to='/sponsoren-und-partner/' className='has-text-primary'>Sponsoren</Link>
              </FooterLink>
            </Fade>
          </MobileExpander>

          <MobileExpander onClick={handleShowExploreLinks}>
            <h4 className='subtitle is-6 has-text-weight-medium' style={{ color: 'var(--color-text)', display: 'inline-block', margin: '0px' }}>
              Entdecken
            </h4>
            {showExploreLinks ? <img src={minusIcon} alt='schließen' style={{ width: '1.4rem', height: '1.4rem' }} className='is-pulled-right' onClick={handleShowExploreLinks} /> : <img src={plusIcon} alt='öffnen' className='is-pulled-right' style={{ width: '1.4rem', height: '1.4rem' }} onClick={handleShowExploreLinks} /> }

            <Fade collapse when={showExploreLinks}>
              <FooterLink>
                <Link to='/mannschaften/' className='has-text-primary'>Mannschaften</Link>
              </FooterLink>
              <FooterLink>
                <Link to='/#news' className='has-text-primary'>News</Link>
              </FooterLink>
              <FooterLink>
                <Link to='/#termine' className='has-text-primary'>Termine</Link>
              </FooterLink>
              
            </Fade>
          </MobileExpander>

          <MobileExpander onClick={handleShowHelpLinks}>
            <h4 className='subtitle is-6 has-text-weight-medium' style={{ color: 'var(--color-text)', display: 'inline-block', margin: '0px' }}>
              Kontakt
            </h4>
            {showHelpLinks ? <img src={minusIcon} alt='schließen' style={{ width: '1.4rem', height: '1.4rem' }} className='is-pulled-right' /> : <img src={plusIcon} alt='öffnen' className='is-pulled-right' style={{ width: '1.4rem', height: '1.4rem' }} onClick={handleShowHelpLinks} /> }

            <Fade collapse when={showHelpLinks}>
              {/* <Link to='/' className='has-text-primary'>Kontaktadresse</Link>
              <Link to='/' className='has-text-primary'>Email</Link> */}
              <div style={{ color: 'var(--color-text)' }}>
                <p>SV-App</p>
                <p>Mustermannstraße 10</p>
                <p>Österreich</p>
              </div> 
              <br />
            </Fade>
          </MobileExpander>

          {showHelpLinks ?
            <div style={{ margin: '0rem auto', textAlign: 'center', padding: '2rem' }}>
              <Map height={300} defaultCenter={[47.95324476741876, 14.785445518537268]} defaultZoom={12}>
                <Marker
                  width={45}
                  anchor={[47.95324476741876, 14.785445518537268]}
                  color={color}
                  onClick={() => setShowInfo(true)}
                />
                <ZoomControl
                  // buttonStyle={{ background: 'black', color: 'white' }}
                />
                <Overlay anchor={[47.95324476741876, 14.785445518537268]} offset={[30, 10]}>
                  <img src={logo} width={50} height={50} alt='' />
                </Overlay>
              </Map>
              {renderInfo()}
            </div>
            : null}

          <MobileExpander onClick={handleShowPrivacyLinks}>
            <h4 className='subtitle is-6 has-text-weight-medium' style={{ color: 'var(--color-text)', display: 'inline-block', margin: '0px' }}>
              Rechtliches
            </h4>
            {showPrivacyLinks ?
              <img src={minusIcon} alt='schließen' style={{ width: '1.4rem', height: '1.4rem' }} className='is-pulled-right' onClick={handleShowPrivacyLinks} /> : <img src={plusIcon} alt='öffnen' className='is-pulled-right' style={{ width: '1.4rem', height: '1.4rem' }} /> }

            <Fade collapse when={showPrivacyLinks}>
              <FooterLink>
                <Link to='/impressum' className='has-text-primary'>Impressum</Link>
              </FooterLink>
              <FooterLink>
                <Link to='/datenschutz' className='has-text-primary'>Datenschutz</Link>
              </FooterLink>
            </Fade>
          </MobileExpander>

        </LazyLoad>
      </footer>
      <div className='column is-12' style={{ marginTop: '3rem', marginBottom: '1rem' }}>
        <div className='has-text-centered'>
          <p style={{ color: 'var(--color-text)' }}>©{' '}{mainpitch.copyright}{' '}<a className='has-text-primary' href='https://www.digital-comfort-zone.com' rel='noopener noreferrer'>digital-comfort-zone</a>{' '}{new Date().getFullYear()}</p>
        </div>
      </div>
    </div>
  )
}

const Footer = props => {
  if (!props.data) {
    return null
  }
  const data = props.data.edges[0].node.frontmatter
  return <FooterTemplate data={data} />
}

export { Footer }

const DesktopLinks = styled.div`
  display: none;
  @media(min-width: 779px){
    // background: rgba(0,0,0,0.8);
    display: block;
    max-width: 1400px;
    margin: 2rem auto;

`

const MobileExpander = styled.div`
  display: none;
  @media(max-width: 779px){
    background: var(--color-background);
    display: block;
    padding: 10px;
    border-top: 1px solid grey;
    border-bottom: 1px solid grey;
    // height: auto;
    overflow: hidden;
    &:hover{
      cursor: pointer;
    }
  }
`

const FooterLink = styled.div`
  padding-top: 5px;
  padding-bottom: 5px;
`

const InfoBg = styled.div`
  position: absolute;
  bottom: 250px;
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  background: #fff;
  height: auto;
  width: auto;
  max-width: 350px;
  padding: 20px 10px;
  box-shadow: 0 0 20px rgba(0,0,0,.5);
`

const InfoCloseBtn = styled.span`
  position: absolute;
  z-index: 3001;
  right: 0px;
  top: 0px;
  color: #fff;
  font-size: 16px;
  padding-top: 3px;
  cursor: pointer;
  background: #fff;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 100%;
`
